module.exports = __webpack_public_path__ + "img/empty_box.06b26b32.png";